import { render, staticRenderFns } from "./LicenceFeatures.vue?vue&type=template&id=6d9b5c84"
import script from "./LicenceFeatures.vue?vue&type=script&lang=js"
export * from "./LicenceFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports